import { render } from "./MapWidget.vue?vue&type=template&id=973c965a&scoped=true"
import script from "./MapWidget.vue?vue&type=script&lang=js"
export * from "./MapWidget.vue?vue&type=script&lang=js"

import "./MapWidget.vue?vue&type=style&index=0&id=973c965a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973c965a"]])

export default __exports__